import { render, staticRenderFns } from "./BaseControl.vue?vue&type=template&id=bed056fa"
import script from "./BaseControl.vue?vue&type=script&lang=js"
export * from "./BaseControl.vue?vue&type=script&lang=js"
import style0 from "./BaseControl.vue?vue&type=style&index=0&id=bed056fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports